import { render, staticRenderFns } from "./OrderItemList.vue?vue&type=template&id=62eee4de&lang=pug&"
import script from "./OrderItemList.vue?vue&type=script&lang=js&"
export * from "./OrderItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports